import { connect } from 'react-redux';

import UserRolesGrid from './UserRolesGrid';

const mapStateToProps = state => {
  return {
    roleList: state.rolesPermissions.roleList,
  };
};

export default connect(mapStateToProps)(UserRolesGrid);
